import { render, staticRenderFns } from "./NewRequest.vue?vue&type=template&id=07008036&scoped=true"
import script from "./NewRequest.vue?vue&type=script&lang=ts"
export * from "./NewRequest.vue?vue&type=script&lang=ts"
import style0 from "./NewRequest.vue?vue&type=style&index=0&id=07008036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07008036",
  null
  
)

export default component.exports